<template>
  <div
    class="TradeClientOrderForm MSWForm"
    style="background-color: rgb(255,255,255)"
  >
    <div class="internal-container mx-auto">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" xl="6">

                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <span class="label">Email Address:</span>
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        outlined
                        required
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">Project/Client:</span>
                      <v-text-field
                        v-model="project"
                        outlined
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <span class="label">Name/Company:</span>
                      <v-text-field
                        v-model="name"
                        :rules="required"
                        outlined
                        required
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">Other Reference:</span>
                      <v-text-field
                        v-model="requirements"
                        outlined
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- 
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            color="grey"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="date"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save"
                          color="grey"
                        ></v-date-picker>
                      </v-menu>
                    </v-col> 
                    <v-col cols="12">
                      <span class="label">Payment Type</span>
                      <v-radio-group v-model="radioGroup" color="grey">
                        <v-radio
                          label="Credit Card"
                          value="Credit Card"
                          color="grey"
                        ></v-radio>
                        <v-radio label="Check" value="Check" color="grey"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  -->
                  <v-row>
                    <v-col cols="12">
                      <span class="label">Company Address</span>
                      <v-text-field
                        v-model="billingAddress"
                        outlined
                        :rules="required"
                        color="grey"
                      ></v-text-field>
                    </v-col>
                    <!--
                      <v-col cols="12">
                        <span class="label">Street Address</span>
                        <v-text-field
                          v-model="streetAddress"
                          outlined
                          color="gray"
                        ></v-text-field>
                      </v-col>
                    -->
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <span class="label">City</span>
                      <v-text-field
                        v-model="city"
                        outlined
                        :rules="required"
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">State</span>
                      <v-text-field
                        v-model="state"
                        outlined
                        :rules="required"
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <span class="label">Zip Code</span>
                      <v-text-field
                        v-model="zipCode"
                        outlined
                        :rules="required"
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">Add Resale Certificate</span>
                      <v-file-input
                        v-model="files"
                        outlined
                        color="black"
                        class="mx-auto"
                        multiple
                        chips
                        :prepend-icon="false"
                        prepend-inner-icon="mdi-paperclip"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-form>
              
                <button 
                  @click="validate"
                  class="MSWButton"
                >
                  Submit
                </button>

                <span class="ml-12 label d-inline-block" v-if="showThankyou">Thank you!</span>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default {
    data () {
        return {
            valid : false,
            date: null,
            menu: false,
            radioGroup: null,
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            required: [
                v => !!v || 'Required'
            ],
            project: '',
            name: '',
            requirements: '',
            billingAddress: '',
            streetAddress: '',
            city: '',
            state: '',
            zipCode: '',
            files: [],
            showThankyou: false
        }
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    mounted: function () {
        this.$emit("update", 6);
    },
    methods: {
      save (date) {
        this.$refs.menu.save(date)
      },
      validate () {
        if(this.$refs.form.validate()){

          var aux = this;

          let datos = new FormData();

          for (let index = 0; index < this.files.length; index++) {
              datos.append("files[" + index + "]", this.files[index]);
          }

          let config = {
              header: {
                "Content-Type": "multipart/form-data"
              }
          };

          if(this.files.length > 0){

            axios.post(
              "https://www.artlesscms.actstudio.xyz/api/cockpit/addAssets?token=cf00a9204acb3ab54e671ca7655e5f",
              datos,
              config
            )
            .then(function (res) {
              var routes = [];
  
              for (let index = 0; index < res.data.assets.length; index++) {
                  const element = res.data.assets[index].path;
                  routes.push(element);
              }
  
              let data = {
                  'Email': aux.email,
                  'Project': aux.project,
                  'Name': aux.name,
                  'OtherReferences': aux.requirements,
                  'CompanyAddress': aux.billingAddress,
                  'City': aux.city,
                  'State': aux.state,
                  'ZipCode': aux.zipCode,
                  'File': "https://www.artlesscms.actstudio.xyz/storage/uploads" + routes[0]
              }
  
              fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/MSWTradeClientOrderForm?token=cf00a9204acb3ab54e671ca7655e5f', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                      form: data
                  })
              })
              .then(entry => entry.json())
              .then(aux.copiaCollection(data))
              .then(aux.reiniciar());
            });
          }else{
            let data = {
                  'Email': aux.email,
                  'Project': aux.project,
                  'Name': aux.name,
                  'OtherReferences': aux.requirements,
                  'CompanyAddress': aux.billingAddress,
                  'City': aux.city,
                  'State': aux.state,
                  'ZipCode': aux.zipCode
              }
  
              fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/MSWTradeClientOrderForm?token=cf00a9204acb3ab54e671ca7655e5f', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                      form: data
                  })
              })
              .then(entry => entry.json())
              .then(aux.copiaCollection(data))
              .then(aux.reiniciar());
          }

        }
      },
      copiaCollection: function (formData){
        /*
        fetch('https://www.artlesscms.actstudio.xyz/api/collections/save/MSWTradeClientOrderForm', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                data: formData
            })
        })
        .then(res=>res.json());
        */
      },
      reiniciar: function () {
        this.showThankyou = true;
        setTimeout(() => {
          this.showThankyou = false;
        }, 5000);
      }
    }
}
</script>